(()=> {
    let timeout;
    let debounceActive = false;
    let tabsElemt = document.querySelectorAll('.yq-body-16-400');
    let orderForm = document.getElementById('orderForm');
    let trackingForm = document.getElementById('trackingForm');
    tabsElemt.forEach(function(item) {
        item.addEventListener('click', function() {
            tabsElemt.forEach(function(otherTab) {
                otherTab.classList.remove('active');
            });
            this.classList.add('active');
            if(item.dataset.id == 1){
                orderForm.style.display = 'none';
                trackingForm.style.display = 'block';
            }else{
                trackingForm.style.display = 'none';
                orderForm.style.display = 'block';
            }
        });
    });
    let orderNumber = document.getElementById('orderForm_order_no');
    let userEmail = document.getElementById('orderForm_user_email');
    let trackingNumber = document.getElementById('trackingNumber');

    let orderError = document.getElementById('orderError');
    let emailError = document.getElementById('emailError');
    let trackingError = document.getElementById('trackingError');
    //追踪号携带进链接直接请求接口
    let currentUrl = window.location.href;
    let numsValue = getNumsParameterFromUrl(currentUrl);
    if(numsValue){
        orderForm.style.display = 'none';
        trackingForm.style.display = 'block';
        tabsElemt.forEach(function(otherTab) {
            otherTab.classList.remove('active');
        });
        tabsElemt[1].classList.add('active');
        trackingNumber.value = numsValue;
        register(numsValue)
    }
    //订单号校验
    orderNumber.addEventListener('blur', function(ele) {
        if(checkInput(1,orderNumber.value,orderError)) return;
    });
    //邮箱校验
    userEmail.addEventListener('blur', function(ele) {
       if(checkInput(2,userEmail.value,emailError)) return;
    });
    //跟踪号校验
    trackingNumber.addEventListener('blur', function(ele) {
       if(checkInput(3,trackingNumber.value,trackingError)) return;
    });
    //订单号提交
    orderForm.addEventListener('submit',function(event) {
        event.preventDefault();
        if(checkInput(1,orderNumber.value,orderError)) return;
        if(checkInput(2,userEmail.value,emailError)) return;
        console.log('=======',orderNumber.value,userEmail.value)
        register(orderNumber.value,userEmail.value)
    })
     //追踪号提交
    trackingForm.addEventListener('submit',function(event) {
        event.preventDefault();
        if(checkInput(3,trackingNumber.value,trackingError)) return;
        register(trackingNumber.value)
    })
    //输入框校验
    function checkInput(type,value,that){
        let isTrue = false;
        if(type == 1 && !value){ //订单号
            that.innerHTML = 'Please enter order number.';
            isTrue = true;
        }else if(type == 2){ //邮箱  
            if(!value) {
                that.innerHTML = 'Please enter a valid email address.';
                isTrue = true;
            }else{
                const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if(!emailRegex.test(value)){
                    that.innerHTML = 'Please enter a valid email address.';
                    isTrue = true;
                }
            }   
        }else if(type == 3){ //跟踪号
            if(!value) {
                that.innerHTML = 'Please enter tracking number.';
                isTrue = true;
            }else{
                if (value.length < 5 || value.length > 50) {
                    that.innerHTML = 'Invalid, tracking number must be a combination of alphanumeric characters of 5-50 characters in length.';
                    isTrue = true;
                }
            }
        }  
        if(isTrue){
            that.style.display = 'block';
        }else{
            that.style.display = 'none';
        }
        return isTrue
    }
    document.addEventListener('DOMContentLoaded', function() {
        let element = document.querySelector('.yq-showMore');
        let trackRealTime = document.getElementById('trackRealTime')
        //点击查看更多实时物流信息
        element.addEventListener('click', function() {
            let tracknode = trackRealTime.querySelectorAll('.yq-line-details')
            if(tracknode.length != 0){
                tracknode.forEach(function(item,index) {
                    if(index > 2){
                        item.style.display = item.style.display == 'none' ? 'flex' : 'none';
                        let svg = element.querySelector('svg');
                        if(item.style.display == 'none'){
                            svg.style.transform = 'rotate(0)'
                        }else{
                            svg.style.transform = 'rotate(180deg)'
                        }
                    }
                })
            }
        });
        //点击复制运单号
        let copyNumber = trackRealTime.querySelectorAll('.copy-number')
        copyNumber.forEach(function(item,index) {
            item.addEventListener('click',function() {
                let text = item.textContent;
                navigator.clipboard.writeText(text);

                if(!document.querySelector('.yq-alterFixed')){
                    let htmlBody = document.body;
                    let newDiv = document.createElement('div')
                    newDiv.className = 'yq-alterFixed'
                    htmlBody.appendChild(newDiv);
                    divistrue = true;
                }
                let alterFixed = document.querySelector('.yq-alterFixed')
                let divLi = document.createElement('div')
                divLi.className = 'li'
                divLi.textContent = 'Copy successful';
                alterFixed.appendChild(divLi);
                setTimeout(() => {
                    divLi.style.display = 'none';
                }, 2000);
            })
        })
    });
    function register(orderNumber = '',userEmail = ''){
        orderNumber = orderNumber.replace(/\s+/g, '')
        userEmail = userEmail.replace(/\s+/g, '')
        debounceApi(()=>{
            let alterFixed = document.querySelector('.not-found-requst')
            let alterMessage = document.querySelector('.found-requst-message')
            alterFixed.style.display = 'none';
            alterMessage.style.display = 'none';
            scrollIntoView(true)
            let shopLanguage = document.querySelector('.shop_language');
            let params = {};
            let urlTrack = 'https://app.funny-fuzzy.com/web/tracking/shopify';
            if(userEmail){
                params = {
                    language: shopLanguage.id || '',
                    site: window._site || '',
                    email: userEmail || '',
                    number: orderNumber || '',
                };
            }else{
                params = {
                    language: shopLanguage.id || '',
                    site: window._site || '',
                    trackNumber: orderNumber || '',
                };
            }
            fetch(urlTrack, {
                body: JSON.stringify(params),
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
            }).then(response => {
                if (!response.ok) { throw new Error('网络响应错误')}
                return response.json();
            }).then(res => {
                if(res.code == 200){
                    resTrackingDetails(res.data,res.data.trackingList[0])
                }else if(res.code == 504){ //17TRACK 异常：504 
                    let track = document.getElementById('17TRACK');
                    if(trackingNumber.value){
                        track.href = `https://www.17track.net/en#nums=${trackingNumber.value}`
                    }else{
                        let arrNumber = res.data.trackNumbers || [];
                        track.href = `https://www.17track.net/en#nums=${arrNumber.join(',')}`
                    }
                    alterMessage.style.display = 'block';
                    let trackingLoading = document.getElementById('yq-tracking-loading');
                    trackingLoading.style.display = 'none';
                }else { //参数校验错误： 400 //服务器内部错误：500
                    alterFixed.style.display = 'block';
                    let trackingLoading = document.getElementById('yq-tracking-loading');
                    trackingLoading.style.display = 'none';
                }
            }).catch(error => {
                console.error(error)
                alterFixed.style.display = 'block';
                let trackingLoading = document.getElementById('yq-tracking-loading');
                trackingLoading.style.display = 'none';
            })
        },2000)
    }
    /*
    * 物流详情接口返回值处理
    * resData接口总返回，trackingList为订单编号里拆分运单条数，tracking为该条运单里面的实时物流动态
    * resObj为当前运单里面的实时物流信息
    */
    function resTrackingDetails(resData = {},resObj = {},tabIndex = 0){
        // console.log('-----------',resData,resObj,tabIndex)
        //订单编号中是否有多条运单号，进行运单号切换和显示
        let PackageTab = document.querySelector('.PackageTab_packageTab__kgI7R');
        if(resData.trackingList.length > 1){
            PackageTab.style.display = 'block';
            let PackageTabChild = PackageTab.querySelector('.PackageTab_packageTab__kgI7R ul');
            PackageTabChild.innerHTML = '';
            resData.trackingList.forEach(function(item,index) {
                let div = document.createElement('li');
                if(index == tabIndex){
                    div.className = "yq-body-14-400 PackageTab_package__77LD3 yq-flex-1 PackageTab_selected__FW6Il";
                }else{
                    div.className = "yq-body-14-400 PackageTab_package__77LD3 yq-flex-1";
                }
                div.innerHTML = `Package #${index+1}`;
                div.setAttribute('data-id', index);
                div.addEventListener('click', function() {
                    let id = this.getAttribute('data-id');
                    if(id != tabIndex){
                        resTrackingDetails(resData,resData.trackingList[id],id)
                    }
                });  
                PackageTabChild.appendChild(div);  
            })
        }else{
            PackageTab.style.display = 'none';
        }
        let getChangeDetails = document.getElementById('getChangeDetails');
        let orderTrackError = document.getElementById('orderTrackError');
        let trackRealTime = document.getElementById('trackRealTime');
        if(resObj.tracking){
            getChangeDetails.innerHTML = '';
            let shopEvents = resObj.tracking?.providers && resObj.tracking.providers[0].events || [];
            if(shopEvents.length > 0){
                orderTrackError.style.display = 'none';
                trackRealTime.style.display = 'block';
                //物流实时追踪信息
                shopEvents.forEach(function(item,index) {
                    let div = document.createElement('div');
                    div.className = "yq-flex yq-line-details yq-gap-4 yq-body-14-400";
                    if(index > 2){
                        div.style.display = 'none';
                        let element = document.querySelector('.yq-showMore');
                        element.style.display = 'flex';
                    }
                    let dateSpan = document.createElement('span');
                    dateSpan.className = "time";
                    let { datePart, timePart } = splitDateTime(item.time_utc);
                    dateSpan.innerHTML = `${datePart}<br>${timePart}`;
                    // dateSpan.innerHTML = `${item.time_raw?.date}<br>${item.time_raw?.time}`;

                    let contentSpan = document.createElement('span');
                    contentSpan.className = "content";
                    contentSpan.textContent = item.description_translation ? item.description_translation.description : item.description;

                    div.appendChild(dateSpan);
                    div.appendChild(contentSpan);
                    getChangeDetails.appendChild(div);
                })
                //物流配送公司信息
                let logisticsCompany = trackRealTime.querySelectorAll('.logistics-company li');
                logisticsCompany.forEach(function(item,index) {
                    if(index == 0){
                        let name = item.querySelector('.name')
                        name.innerHTML = resObj.trackingCompany;
                        let span = item.querySelector('.copy-number span')
                        span.innerHTML = resObj.trackingNumber;
                    }
                    if(index == 2){
                        let span = item.querySelector('.copy-number span')
                        span.innerHTML = resObj.phone || resObj.trackingNumber;
                    }
                })
            }else{
                orderTrackError.style.display = 'block';
                trackRealTime.style.display = 'none';
            }
        }else{
            orderTrackError.style.display = 'block';
            trackRealTime.style.display = 'none';
        }
        //商品信息展示
        let shopDetails = document.querySelector('.MatrixOrderInfo_matrixOrderInfo__L7OyO');
        let shopNumber = shopDetails.querySelectorAll('.orderNumber');
        shopNumber.forEach(function(item,index){
            if(index == 0){
                let address = resObj.destination || '--';
                item.innerHTML = address;
            }
            if(index == 1){
                let days = resObj.dayTimeDifference || '--';
                if(days){ days + 'Days' }
                item.innerHTML = days;
            }
            if(index == 2){ item.innerHTML = resData.name || '--';}
        })
        let shopSlpacsUl = shopDetails.querySelector('.shop-list-all');
        shopSlpacsUl.innerHTML = ''; // 清空容器
        let lineItems = resObj.products || [];
        lineItems.forEach(function(item,index){
            const productElement = document.createElement('div');
            productElement.className = "carts-product-item";
            productElement.innerHTML = `
                <li class="yq-body-14-400">
                    <div class="yq-flex yq-items-center yq-gap-4">
                        <div class="yq-flex yq-items-center yq-justify-center MatrixOrderInfo_cover__etcau">
                            <img src="${item.variantImage}" alt="${item.variantImage}">
                        </div>
                        <div class="yq-flex-1 yq-flex yq-flex-col yq-gap-1">
                            <div class="yq-flex yq-items-center yq-justify-between yq-gap-4">
                                <a href="${item.variantUrl}" target="_blank" rel="noreferrer" class="yq-flex-1 yq-normal-break yq-line-clamp-2 yq-underline" title="${item.variantName}">${item.variantName}</a>
                                <div class="yq-order-info-price">${resData.currency}${item.price}</div>
                            </div>
                            <div class="yq-flex yq-items-center yq-justify-between yq-gap-4 yq-secondary-color">
                                <div class="yq-flex-1 yq-flex yq-flex-wrap yq-visible yq-normal-break" title="${item.variantSku || ''}">${item.variantSku || ''}</div>
                                <div>× ${item.variantQuantity}</div>
                            </div>
                        </div>
                    </div>
                </li>
            `;
            shopSlpacsUl.appendChild(productElement);
        })
        
        //实时物流步骤进度条
        let trackStep = document.querySelectorAll('.MatrixTrackProcess_anto')
        let transportationTitle = document.querySelector('.TrackProcess__gFaLC h1')
        let trackBg = document.querySelectorAll('.MatrixTrackProcess_step__xBqlM')
        let trackBlock = document.querySelectorAll('.MatrixTrackProcess_line__Ss7_B')[1];
        let tbx = 0;
        trackStep.forEach(function(item,index) {
            let trackName = item.querySelector('.MatrixTrackProcess_status__XXdr9')
            let dataPlace = trackName.getAttribute('data-place');
            let status = resObj.latestStatus || 'InfoPending'; //目前物流处于状态，查询不到则默认物流状态
            if(status == 'NotFound' || status == 'InfoPending'){ //查询不到，进行查询操作但没有得到结果，原因请参看子状态。
                status = 'InfoPending';
                transportationTitle.innerHTML = 'We are preparing your order for dispatch.';
                trackBlock.style.width = '0';
            }
            if(status == 'InfoReceived'){ //收到信息，运输商收到下单信息，等待上门取件。
                status = 'InfoReceived';
                transportationTitle.innerHTML = 'Your order is placed and is about to be shipped.'
                trackBlock.style.width = '20%';
            }
            if(status == 'Expired' || status == 'InTransit'){ //运输过久，包裹已经运输了很长时间而仍未投递成功。
                status = 'InTransit';
                transportationTitle.innerHTML = 'Your order is in transit.'
                trackBlock.style.width = '40%';
            }
            if(status == 'OutForDelivery' || status == 'DeliveryFailure' || status == 'AvailableForPickup'){ //派送途中，包裹正在投递过程中。//投递失败，包裹尝试派送但未能成功交付，原因请参看子状态。原因可能是：派送时收件人不在家、投递延误重新安排派送、收件人要求延迟派送、地址不详无法派送、因偏远地区不提供派送服务等。
                status = 'AvailableForPickup';
                if(status == 'OutForDelivery'){
                    transportationTitle.innerHTML = 'Your order is being delivered.'
                    trackBlock.style.width = '70%';
                }else{
                    transportationTitle.innerHTML = 'Your order is now available for pickup.'
                    trackBlock.style.width = '60%';
                } 
            }
            if(status == 'Exception' || status == 'Delivered'){ //可能异常，包裹可能被退回，原因请参看子状态。原因可能是：收件人地址错误或不详、收件人拒收、包裹无人认领超过保留期等。包裹可能被海关扣留，常见扣关原因是：包含敏感违禁、限制进出口的物品、未交税款等。包裹可能在运输途中遭受损坏、丢失、延误投递等特殊情况。
                status = 'Delivered';
                transportationTitle.innerHTML = 'Your order has been delivered.'
                trackBlock.style.width = '80%';
            }
            item.classList.remove('resAchieve');
            item.classList.remove('makeItSuccess');
            if(dataPlace == status){
                tbx = index;
                item.classList.add('makeItSuccess');
                trackName.style.display = 'block';
            }
            if(!tbx && status != 'InfoPending'){
                item.classList.add('resAchieve');
            }
            if (window.innerWidth < 750 && dataPlace != status) {
                trackName.style.display = 'none';
            }
        });
        trackBg.forEach(function(item,index) {
            item.classList.remove('makeItWill');
            if(index == tbx){
                item.classList.add('makeItWill');
            }
        })
        scrollIntoView()
    }
    //滚动位置处理
    function scrollIntoView(longing = ''){
        let trackingDetailsAll = document.getElementById('trackingDetailsAll')
        let trackingLoading = document.getElementById('yq-tracking-loading');
        let trackingDetails = document.getElementById('trackingDetails')
        if(longing){
            trackingLoading.style.display = 'flex';
            trackingDetails.style.display = 'none'; 
        }else{
            trackingDetails.style.display = 'block'; 
            trackingLoading.style.display = 'none';
        }
        if (window.innerWidth < 750) {
            if(!longing){
                trackingDetailsAll.scrollIntoView({ block: 'start' });
            } 
        }else{
            let scrollContainer = document.querySelector('.MatrixTheme_columns__WO12L')
            scrollContainer.scrollTo({
                top: 580,
                behavior: 'auto'
            });
        }
    }
    function splitDateTime(dateTimeStr) {
        const regex = /(\d+ \w+, \d{4}) (\d+:\d+)/;
        const match = dateTimeStr.match(regex);
        if (match) {
            const datePart = match[1]; // 日期部分
            const timePart = match[2]; // 时间部分
            return { datePart, timePart };
        } else {
            throw new Error('Invalid date-time format');
        }
    }
    function getNumsParameterFromUrl(url) {
        const urlObj = new URL(url);
        const params = new URLSearchParams(urlObj.search);
        if (params.has('nums')) {
            return params.get('nums');
        } else {
            return '';
        }
    }
    function debounceApi(func, wait) {
        if (debounceActive) return;
        debounceActive = true;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            debounceActive = false;
        }, wait);
        func();
    }
})()